import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Voltsuccess = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-green-50 p-6">
      <CheckCircle2 className="text-green-600 w-20 h-20 mb-5" />
      <h1 className="text-3xl font-bold text-green-700 mb-3">Payment Successful!</h1>
      <p className="text-gray-700 text-center mb-8 max-w-md">
        Thank you for your payment. Your transaction has been completed successfully.
      </p>

      <button
        onClick={() => (window.location.href = 'fxmaster://payment-success')}
        className="
          px-8 py-3 
          rounded-full 
          bg-gradient-to-r from-green-500 to-emerald-600 
          text-white 
          font-semibold 
          shadow-lg 
          hover:shadow-xl 
          transform hover:scale-105 
          transition-all 
          duration-300
          focus:outline-none 
          focus:ring-2 
          focus:ring-green-400 
          focus:ring-offset-2
        "
      >
        Go Back to Fx Master
      </button>
    </div>
  );
};

export default Voltsuccess;
